import { TemplateGroupList } from './TemplateGroupList';

type PaymentPlanTemplatesProps = {
  searchQuery: string;
};

export const PaymentPlanTemplates = ({ searchQuery }: PaymentPlanTemplatesProps) => (
  <TemplateGroupList
    templateType="payment_plan"
    stepTypes={PAYMENT_PLAN_GROUP_STEP_TYPES}
    searchQuery={searchQuery}
  />
);

const PAYMENT_PLAN_GROUP_STEP_TYPES = [
  'plan_creation',
  'plan_update',
  'plan_cancel',
  'preventive_reminder',
  'first_reminder',
  'intermediate_reminder',
  'last_reminder',
] as const;
